// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1310":"9b2f3d9d","1650":"6e3fcf45","1651":"ccad4742","5399":"ccad4742","7199":"ccad4742","7953":"9b2f3d9d","8717":"ccad4742","9357":"ccad4742"}[chunkId] + ".chunk.css";
};